import PropTypes from 'prop-types';

// eslint-disable-next-line react/forbid-prop-types
export default PropTypes.object;
